module.exports = __webpack_public_path__ + "img/bg-login.a1692646.jpg";